export enum Status {
  Unknown,
  Success,
  Failure
}



// WEBPACK FOOTER //
// ./src/components/Status.ts